import { css } from '@emotion/core'

export const fontSize = (fs) => css`
  font-size: ${fs} !important;
`

export const display = (d) => css`
  display: ${d} !important;
`

// POSITIONING
export const margin = (m) => css`
  margin: ${m} !important;
`

export const marginTop = (mt) => css`
  margin-top: ${mt} !important;
`

export const marginBottom = (mb) => css`
  margin-bottom: ${mb} !important;
`

export const marginInlineStart = (ml) => css`
  margin-inline-start: ${ml} !important;
`

export const marginInlineEnd = (mr) => css`
  margin-inline-end: ${mr} !important;
`

export const marginVertical = (mv) => css`
  margin-bottom: ${mv} !important;
  margin-top: ${mv} !important;
`

export const marginHorizontal = (mh) => css`
  margin-inline-start: ${mh} !important;
  margin-inline-end: ${mh} !important;
`

export const padding = (p) => css`
  padding: ${p} !important;
`

export const paddingTop = (pt) => css`
  padding-top: ${pt} !important;
`

export const paddingBottom = (pb) => css`
  padding-bottom: ${pb} !important;
`

export const paddingInlineStart = (pl) => css`
  padding-inline-start: ${pl} !important;
`

export const paddingInlineEnd = (pr) => css`
  padding-inline-end: ${pr} !important;
`

export const paddingVertical = (pv) => css`
  padding-bottom: ${pv} !important;
  padding-top: ${pv} !important;
`

export const paddingHorizontal = (ph) => css`
  padding-inline-start: ${ph} !important;
  padding-inline-end: ${ph} !important;
`

export const showElement = (show) => {
  return {
    transform: show ? 'scale(1)' : 'scale(0)',
    visibility: show ? 'visible' : 'hidden',
    transition: 'all .3s',
  }
}

export const aTag = css`
  color: rgb(6, 111, 144);

  :visited {
    color: rgb(192, 40, 92);
  }
`
